import { escapeRegExp as p } from "../../string/escapeRegExp.js";
import { toString as r } from "../util/toString.js";
function a(e) {
  return p(r(e));
}
export { a as escapeRegExp };